import { useEffect, useRef, useState } from "react";
import { LoginButton } from "../components/LoginButton";
import { useTheme } from "../../../context/useThemeContext";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import { deleteUser } from "../../../utility/backend/authentication";

export default function DeleteAccountConfirm() {
    const { theme } = useTheme();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const { userData, setUserData, setLoginState } =
        useAccountManagementStore();

    useEffect(() => {
        if (userData.email !== undefined) {
            setEmail(userData?.email);
        } else {
            setEmail("");
        }
    }, [userData]);

    function deleteAccount() {
        deleteUser()
            .then((deletedAccount) => {
                if (deletedAccount === true) {
                    setUserData(null);
                    setLoginState("default");
                } else {
                    throw new Error("Failed to delete account");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <form
            id="signOutForm"
            className="flex flex-col p-9 pb-7 text-center text-white"
            onSubmit={(e) => e.preventDefault()}
        >
            <b className="mb-4 text-2xl">Confirm Deletion</b>

            <div style={{ color: theme.fontColor[100] }}>
                <p>Are you sure you want to delete this account?</p>
                <p>All data associated with this account will be deleted.</p>
            </div>
            <div className="mb-6" />
            <LoginButton
                type="submit"
                className="mb-1 mt-4 h-[36px] rounded text-sm"
                style={{
                    backgroundColor: theme.accentColor,
                }}
                onClick={() => {
                    setLoginState("updateAccount");
                }}
            >
                Cancel
            </LoginButton>
            <TimeoutButton
                buttonColor="#ce1811"
                onTimeout={() => {
                    deleteAccount();
                }}
                timerSeconds={5}
                buttonTitle="Delete Account"
            />
            <u className="pt-2 text-xs" style={{ color: theme.fontColor[100] }}>
                This action cannot be undone.
            </u>
        </form>
    );
}

function TimeoutButton(props: {
    onTimeout: () => void;
    buttonColor: string;
    timerSeconds: number;
    buttonTitle: string;
}) {
    const [isHeld, setIsHeld] = useState(false);
    const countdownRef = useRef<NodeJS.Timeout>(null);
    const timerRef = useRef<NodeJS.Timeout>(null);
    const [currentTime, setCurrentTime] = useState(props.timerSeconds);

    function mouseDown() {
        setIsHeld(true);
        setCurrentTime(props.timerSeconds);

        function decreaseTime() {
            countdownRef.current = setTimeout(() => {
                setCurrentTime((prevValue) => prevValue - 1);
                decreaseTime();
            }, 1000);
        }
        decreaseTime();

        timerRef.current = setTimeout(() => {
            clearTimeout(timerRef.current);
            clearTimeout(countdownRef.current);
            setCurrentTime(props.timerSeconds);
            setIsHeld(false);

            console.log("Timer Ended");
            props.onTimeout();
        }, props.timerSeconds * 1000);
    }

    function mouseUp() {
        clearTimeout(timerRef.current);
        clearTimeout(countdownRef.current);
        setCurrentTime(props.timerSeconds);
        setIsHeld(false);
    }

    return (
        <>
            <LoginButton
                type="submit"
                className="my-1 h-[36px] rounded text-sm"
                style={{
                    backgroundColor: props.buttonColor,
                }}
                // onClick={props.onClick}
                onMouseDown={mouseDown}
                onMouseUp={mouseUp}
                onMouseLeave={mouseUp}
            >
                {`${props.buttonTitle} ${isHeld ? `(${currentTime})` : ""}`}
            </LoginButton>
        </>
    );
}
